import { gql, useQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';

const FETCH_CLIENT_GROUP_NAME = gql`
  query fetchClientGroupName($id: SafeString!) {
    fetchClientGroup(input: { clientGroupId: $id }) {
      clientGroup {
        id: stringId
        name
      }
    }
  }
`;

export function ClientGroupBreadcrumb() {
  const { data } = useQuery(FETCH_CLIENT_GROUP_NAME, {
    variables: { id: useParams().clientGroupId },
  });

  return data ? data.fetchClientGroup?.clientGroup.name : 'Client Group';
}
